export enum GamingProfilEnum {
  PRO = 'PRO',
  CASU = 'CASU',
  SEMIPRO = 'SEMIPRO',
}
